import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingDecoration } from '../../components/NewbuildingDecorationsRedesign';
import { selectIsOfferPageRedesign } from '../../selectors';
import { getDecorationsCount } from '../../selectors/newObject';
import { DecorationItemsRedesign } from './DecorationItemsRedesign';
import { NewbuildingCurrentDecorationContainer } from './NewbuildingCurrentDecoration';
import { NewbuildingDecorationBannerContainer } from './NewbuildingDecorationBanner';

export const NewbuildingDecorationRedesignContainer = () => {
  const decorations = useSelector(getDecorationsCount);
  const isRedesigned = useSelector(selectIsOfferPageRedesign);

  if (!decorations) {
    return <NewbuildingDecorationBannerContainer />;
  }

  return (
    <>
      <NewbuildingCurrentDecorationContainer />
      <NewbuildingDecoration isRedesigned={isRedesigned} items={<DecorationItemsRedesign />} />
    </>
  );
};
